export { default } from './SvgIcon';